export let measurementProfileValueListProps = {
    key: 0,
    id: 0,
    measurement_id: 0,
    measurement_value: ''
}

export let measurementProfileListProps = {
    key: 0,
    registration_date: new Date(),
    id: 0,
    size_id: null,
    measurement_type: 0,//body measurement, ready measurement
    notes: '',
    measured_by_staff_id: null,
    measurement_field_list: []
}

export let measurementCategoryProfileListProps = {
    tailoring_category_id: null,
    profile_list: []
}
/*
//profile_list//
created_at: '',
id: 0,
size_id: null,
measurement_type: 0,//body measurement, ready measurement
measurement_field_list: []
*/
export let photoListProps = {
    key: 0,
    id: 0,
    photo_path: ''
}

export let addressProps = {
    key: 0,
    id: 0,
    contact_name: '',
    address: '',
    address2: '',
    city_id: null,
    province_id: null,
    country_id: null,
    postal_code: '',
    contact_number: '',
    address_digital_map_location: '',
    address_label: '',
    edit_mode: true
}

export let discussionProps = {
    id: 0,
    description: '',
    source: '',
    created_at: new Date(),
    staff_name: ''
}

export let dataProps = {
    id: 0,
    type_of_customer: 0,//individual, business
    tag_list: [],
    customer_code: null,
    company_name: '',
    salutation_id: 1,
    customer_name: '',
    primary_mobile_number_calling_code: null,
    primary_mobile_number: '', 
    secondary_mobile_number_calling_code: null,
    secondary_mobile_number: '', 
    email_address: '', 
    send_alert: true,
    tax_registration_number: '',
    profile_photo: '',
    store_id: 0,
    
    address: '',
    address2: '',
    city_id: null,
    province_id: null,
    country_id: null,
    postal_code: '',
    billing_currency_id: null,
    address_digital_map_location: '',

    married: false,
    date_of_marriage: '',
    date_of_birth: '',

    gender: null,//male, female, other
    age: 0,
    additional_notes: '',

    old_weight: '',
    new_weight: '',
    height: '',
    assigned_to_staff_id: null,

    photo_list: [JSON.parse(JSON.stringify(photoListProps))],
    measurement_profile_list: [],
    temp_measurement_profile_list: [],
    update_master_msmt: false,

    show_master_sheet: true,
    measurement_master_size_id: null,
    measurement_master_measured_by_staff_id: null,
    measurement_master_sheet: [],
    search_key: '',
    google_etag: [],
    google_resource_name: '',

    discussion_list: [JSON.parse(JSON.stringify(discussionProps))],

    address_list: [JSON.parse(JSON.stringify(addressProps))],
    delete_address_list: [],
    loading_measurements: false
}


// WEBPACK FOOTER //
// ./src/store/modules/customerMaster/properties.js